import { useLocation, useParams } from 'react-router-dom';

import AppraisalAuditGutterSelect from './AppraisalAuditGutterSelect';
import AuditTable from './AuditTable';
import Layout from './Layout';
import { useGetAuditHistory } from './hooks';
import { isAppraisalAuditPage } from './utils';

type AuditHistoryParams = {
  pageEnum: string;
  id: string;
  entityEnum: string;
};

export default function AuditHistory() {
  const { pageEnum, id, entityEnum } = useParams<AuditHistoryParams>();
  const { search } = useLocation();
  const {
    data: auditHistory,
    isLoading,
    isError,
  } = useGetAuditHistory(pageEnum, id, entityEnum);

  return (
    <Layout
      pageEnum={pageEnum}
      headerContent={
        isAppraisalAuditPage(pageEnum) && <AppraisalAuditGutterSelect />
      }
      isLoading={isLoading}
      isError={isError}
      isDataEmpty={!auditHistory?.length}
    >
      {auditHistory?.map(({ fieldsAudit, sectionTitle }) => (
        // Keyed by the page and query so each gutter's tables start fresh on cached data.
        <AuditTable
          key={`${pageEnum}${search}:${sectionTitle}`}
          data={fieldsAudit}
          section={{}}
        />
      ))}
    </Layout>
  );
}
